import { ICourseInterface } from '../../interfaces/Website/Courses/CoursesCategory/ICoursesCategory'
import apiService from '../Api'

export class CoursesObjectivesService {
  async list(): Promise<ICourseInterface[]> {
    return apiService.get('course/objective').then((res) => res.data.areas)
  }

  async create(data: { name: string }) {
    return apiService.post('/course/objective', data).then((res) => res.data)
  }

  async update(id: number, data: { name: string }) {
    return apiService.put(`/course/objective/${id}`, data).then((res) => res.data)
  }

  async delete(id: number) {
    return apiService.delete(`/course/objective/${id}`)
  }
}
